import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";

@Injectable()
export class CustomerInquiriesService {
    protected customerInquiriesUrl = `${this.restUrlsConf.appURL}/calls/customer_calls.json`;

    constructor(protected http: HttpClient,
                protected restUrlsConf: RestUrlsConfig) {
    }

    getCustomerInquiries(customerNumber) {
        let jsonData = {
          "ChunkNumber":1,
          "POSCustomerNumber": ""+customerNumber+"",
        };
        return this.http.post(this.customerInquiriesUrl, JSON.stringify(jsonData))
            .pipe(tap((res: HttpResponse<any>) => res, (error: any) => throwError(error)));
    }


}
